import React, { Component } from "react";
import history from "./../history";
import "../Center.css";

class StartDemo extends Component {
  nextScreen = event => {
    history.push(`${process.env.PUBLIC_URL}/Demo`);
  };

  render() {
    return (
      <div className="Start">
        <div className="lander">
          <form>
            <h1>You're All Set.</h1>
            <p>
              Open your wallet to see you have <b>100</b> new tokens in your
              account
            </p>
            <p>
              In the following demo:
              <br />
              <ol>
                <li>You will try to exchange <b>1</b> testnet FRT token.</li>
                <li><b>All</b> your testnet tokens will be "stolen" from your
                account.</li>
              </ol>
              This exploit is in the smart contract level, and can affect many
              crypto and DeFi offerings, such as <b>swap and lending</b>, as
              well as other services making use of <b>smart contracts</b>.
            </p>
            <div className="row bottom">
              <div className="col-md-4">
                <button
                  type="button"
                  className="primary-btn btn-block"
                  onClick={this.nextScreen}
                >
                  Start Demo
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default StartDemo;
